<script>
import { Bar } from "vue-chartjs";
import { API } from "@/api.js";
import { COLORS } from "@/components/colors.js";

export default {
  extends: Bar,
  data: () => ({
    chartdata: {
      labels: [],
      datasets: [
        {
          label: "Remote Assistance",
          backgroundColor: COLORS.Tableau20[0],
          data: [],
            barPercentage: 1,
            categoryPercentage: 0.5,
        },
        {
          label: "Onsite Assistance",
          backgroundColor: COLORS.Tableau20[1],
          data: [],
            barPercentage: 1,
            categoryPercentage: 0.5,
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: true,
      legend: {
        display: true,
        position: "right",
      },
      scales: {
        xAxes: [
          {
            stacked: true,
            
          },
        ],
        yAxes: [
          {
            stacked: true,
          },
        ],
      },
      // radius: 20,
      // clip: 1,
      // backgroundColor: 'rgba(0.2, 0.4, 0.6, 0.1)'
    },
  }),
  props: {
    mcode: String,
    field: String, // k oppure ore
    years: Boolean,
  },
  async mounted() {
    let data = await API.totalNumTicketAss(this.mcode,this.field,this.years);
// console.log("this.chartdata0",data)
    // console.log("mcode,field,years totalNumTicketAss", this.mcode,this.field,this.years);
    // console.log("data totalNumTicketAss", data);
    if(this.years) {
        let newdata = []
        // faccio un primo giro per aggiungere eventuali dati mancanti (anni senza uno dei due tipi di assistenza)
        let anni = data.map(d => d.year)
        anni = [...new Set(anni)]
        let obj
        for(let a of anni) {
            obj = {machine: this.mcode, ticketrem: "Remote Assistance", year: a}
            obj[this.field] = 0
            data.push(obj)
            obj = {machine: this.mcode, ticketrem: "Onsite Assistance", year: a}
            obj[this.field] = 0
            data.push(obj)
        }
        // console.log("d1",JSON.stringify(data,null,2))
        for(let d of data) {
            let i = newdata.find(n => n.year==d.year && n.ticketrem==d.ticketrem)
            if(i) {
                i[this.field] += d[this.field]
            } else {
                let n = {year: d.year, ticketrem: d.ticketrem}
                n[this.field] = d[this.field]
                newdata.push(n)
            }
        }
        data = newdata
        // console.log("d2",JSON.stringify(data,null,2))
        data.sort((a,b) => a.year - b.year)
        this.chartdata.labels = data.map((d) => d.year)
        // console.log("d3",JSON.stringify(data,null,2))
    } else {
        this.chartdata.labels = data.map((d) => d.machine)
    }
    // rendo anche uniche le label
    this.chartdata.labels = [...new Set(this.chartdata.labels)]
    this.chartdata.datasets[0].data = data.filter(d => d.ticketrem=='Remote Assistance').map((d) => d[this.field]);
    this.chartdata.datasets[1].data = data.filter(d => d.ticketrem!='Remote Assistance').map((d) => d[this.field]);
    // console.log("d4",this.chartdata)
    let totalk = data.reduce((acc, d) => acc + d.k, 0);
    // console.log("emit", totalk)
    this.$emit("totalk", totalk)
	// console.log("this.chartdata1",this.years,this.field,this.chartdata)
	// console.log("this.chartdata2",data)
    try {
        this.renderChart(this.chartdata, this.options);
    } catch(e){
        // banale errore fake
    }
  },
};
</script>
<style>
</style>
